<template>
  <v-container>
    <v-alert v-if="error" type="error">{{error}}</v-alert>
    <v-form ref="signupForm" v-model="valid">
      <v-row>
        <v-col cols="12">
          <v-text-field 
            v-model="signupForm.name" 
            label="Display Name"
            :counter="30"
            :rules="nameRules"
            required
          >
          </v-text-field>
        </v-col>

        <v-col cols="12">
          <v-text-field 
            v-model="signupForm.email" 
            label="Email"
            :rules="emailRules"
            required
          >
          </v-text-field>
        </v-col>

        <v-col cols="12">
          <v-text-field
            v-model="signupForm.password" 
            label="Password"
            type="password"
            required
          >
          </v-text-field>
        </v-col>
      </v-row>
      <v-btn @click="submit">Sign Up</v-btn>
    </v-form>
  </v-container>
</template>



<script>
import firebase from "firebase";

export default {
  name: "Register",
  data() {
    return {
      signupForm: {
        name: "",
        email: "",
        password: ""
      },
      error: null,
      valid: false,
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      nameRules: [
        v => !!v || 'Name is required',
        v => (v && v.length <= 30) || 'Name must be less than 10 characters',
      ],
    };
  },
  methods: {
    submit() {
      this.$refs.signupForm.validate();
      firebase
        .auth()
        .createUserWithEmailAndPassword(this.signupForm.email, this.signupForm.password)
        .then(data => {
          data.user
            .updateProfile({
              displayName: this.signupForm.name
            })
        })
        .catch(err => {
          this.error = err.message;
        });
    }
  }
};
</script>